import * as serviceContext from './serviceContext';
import { REPORTS_ROOT as ReportsURL } from '../configs/api';
// import * as constants from '../configs/const';

var options = {};
var headers = new Headers();

headers.append('Content-Type', 'application/json');
options.headers = headers;



export async function postAgentOrder(data) {

    try {
        const response = await serviceContext.post(`masterAgent/orders/place`, JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function postAgentOrderDelete(orderId) {

    try {
        const response = await serviceContext.post(`masterAgent/orders/delete/${orderId}`, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getAgentMarketByMarketId(marketId) {

    try {
        const response = await serviceContext.get(`${ReportsURL}agent/result/open/market/${marketId}`, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getAgentMarketByEventId(eventId) {

    try {
        const response = await serviceContext.get(`${ReportsURL}agent/result/open/event/${eventId}`, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};


export async function postAgentBets(data) {

    try {
        const response = await serviceContext.post(`${ReportsURL}agent/bets`, JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getAgentBets(eventId) {

    try {
        const response = await serviceContext.get(`${ReportsURL}agent/bets/event/${eventId}`, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};